<template>
  <div class="menu-item" @click="$emit('click')">
    <div class="icon">
      <slot />
    </div>
    <div class="label">
      {{ label }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "MenuItem",
    props: {
      label: {
        type: String,
        required: true
      }
    }
  };
</script>

<style scoped lang="scss">
  .menu-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 12px $gutter;
    border-radius: $radius;

    .icon {
      display: block;
      margin-right: 6px;
    }

    .label {
      font-weight: $font-semibold;
      font-size: 18px;
      color: $color-white;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.15);
    }
  }
</style>
